type UseFacebookLogout = {
  logoutFromFacebook: () => void;
};

const useFacebookLogout = (): UseFacebookLogout => {
  const logoutFromFacebook = () => {
    // @ts-ignore
    window.FB.getLoginStatus((auth) => {
      if (auth.status === 'connected') {
        // @ts-ignore
        window.FB.logout();
      }
    });
  };

  return {
    logoutFromFacebook,
  };
};

export default useFacebookLogout;
